"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var data_structures_1 = require("@tableau/data-structures");
var widgets_1 = require("@tableau/widgets");
var react_apollo_1 = require("react-apollo");
var react_router_dom_1 = require("react-router-dom");
var Localize_1 = require("../../../gen-src/Localize");
var FlowFieldDetailsQueryGql_1 = require("../../queries/FlowFieldDetailsQueryGql");
var renderQueryResult_1 = require("../renderQueryResult");
var dialogWidth = 500;
var DetailsPane = data_catalog_shared_1.divWithStyle('DetailsPane', __assign(__assign({}, data_catalog_shared_1.vizPortalFontStyle), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default }));
exports.DetailsName = data_catalog_shared_1.divWithStyle('DetailsName', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
});
var DetailsProperties = data_catalog_shared_1.divWithStyle('DetailsProperties', {
    display: 'table',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
var DetailsProperty = data_catalog_shared_1.divWithStyle('DetailsProperty', {
    display: 'table-row',
});
var DetailsLabel = data_catalog_shared_1.divWithStyle('DetailsLabel', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    textAlign: 'right',
});
var DetailsValue = data_catalog_shared_1.divWithStyle('DetailsValue', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
});
var DetailsPlaceholderMessage = data_catalog_shared_1.divWithStyle('DetailsPlaceholderMessage', {
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
var FlowFieldDetailsDialog = /** @class */ (function (_super) {
    __extends(FlowFieldDetailsDialog, _super);
    function FlowFieldDetailsDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderFlowFieldDetailsDialog = function (data) {
            var flowOutputStep = data.flowOutputSteps && data.flowOutputSteps[0];
            if (!flowOutputStep) {
                return null;
            }
            var flowField = flowOutputStep.outputFields && flowOutputStep.outputFields[0];
            if (!flowField) {
                return null;
            }
            return (React.createElement(widgets_1.DialogWidget, { testId: 'flow-field-details', title: Localize_1.Messages.FieldDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, dialogWidth: dialogWidth, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: _this.props.onClose, handleGlassClick: _this.props.onClose },
                React.createElement(DetailsPane, null,
                    React.createElement(exports.DetailsName, null, flowField.name),
                    _this.renderProperties(flowField))));
        };
        return _this;
    }
    FlowFieldDetailsDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.Query, { query: FlowFieldDetailsQueryGql_1.FlowFieldDetailsQueryGql, variables: { flowOutputStepId: this.props.flowOutputStepId, flowFieldId: this.props.flowFieldId } }, function (result) { return renderQueryResult_1.renderQueryResult(result, { renderData: _this.renderFlowFieldDetailsDialog }); }));
    };
    FlowFieldDetailsDialog.prototype.renderProperties = function (flowField) {
        switch (flowField.__typename) {
            case 'FlowColumnOutputField':
                if (flowField.column) {
                    if (flowField.column.name !== null) {
                        var column_1 = flowField.column;
                        var table = column_1.table;
                        // The table for a column should always be defined.
                        var tableId_1 = table ? table.id : '';
                        var columnName_1 = column_1.name !== null ? column_1.name : Localize_1.Messages.PermissionsRequired();
                        return (React.createElement(DetailsProperties, null,
                            React.createElement(DetailsProperty, null,
                                React.createElement(DetailsLabel, null, Localize_1.Messages.FlowFieldDetails_OutputsToColumn()),
                                React.createElement(DetailsValue, null,
                                    React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
                                        return React.createElement(react_router_dom_1.Link, { className: data_catalog_shared_1.linkClass, to: urls.catalogTableColumnPath(tableId_1, column_1.id), title: columnName_1 }, columnName_1);
                                    })))));
                    }
                    else {
                        return (React.createElement(DetailsPlaceholderMessage, null, Localize_1.Messages.PermissionsRequired()));
                    }
                }
                else {
                    return (React.createElement(DetailsPlaceholderMessage, null, Localize_1.Messages.FlowFieldDetails_OutputColumnUnavailable()));
                }
            case 'FlowFieldOutputField':
                if (flowField.field) {
                    if (flowField.field.name !== null) {
                        var field_1 = flowField.field;
                        var datasource = field_1.datasource;
                        // The datasource for a flow output field should always be defined,
                        // if the field edge is, and it should always be a published data source,
                        // since flows can't output workbooks.
                        var datasourceVizportalUrlId_1 = datasource && datasource.__typename === 'PublishedDatasource' ? datasource.vizportalUrlId : '';
                        var fieldName_1 = field_1.name !== null ? field_1.name : Localize_1.Messages.PermissionsRequired();
                        return (React.createElement(DetailsProperties, null,
                            React.createElement(DetailsProperty, null,
                                React.createElement(DetailsLabel, null, Localize_1.Messages.FlowFieldDetails_OutputsToField()),
                                React.createElement(DetailsValue, null,
                                    React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
                                        return React.createElement(react_router_dom_1.Link, { className: data_catalog_shared_1.linkClass, to: urls.datasourceLineageFieldPath(datasourceVizportalUrlId_1, field_1.id), title: fieldName_1 }, fieldName_1);
                                    })))));
                    }
                    else {
                        return (React.createElement(DetailsPlaceholderMessage, null, Localize_1.Messages.PermissionsRequired()));
                    }
                }
                else {
                    return (React.createElement(DetailsPlaceholderMessage, null, Localize_1.Messages.FlowFieldDetails_OutputFieldUnavailable()));
                }
            default:
                data_structures_1.assertNever(flowField);
                return null;
        }
    };
    return FlowFieldDetailsDialog;
}(React.Component));
exports.FlowFieldDetailsDialog = FlowFieldDetailsDialog;
//# sourceMappingURL=FlowFieldDetailsDialog.js.map